import type { ReactNode } from "react";
import styles from "./HomeNavigations.module.scss";

type TabId = "myRequests" | "myApprovals";

interface ITabConfig {
  id: TabId;
  label: string;
}

const TABS: ITabConfig[] = [
  { id: "myRequests", label: "My requests" },
  { id: "myApprovals", label: "My approvals" },
];

interface IHomeNavigationsProps {
  activeTab: TabId;
  onTabChange: (tabId: TabId) => void;
  onNewRequest?: () => void;
}

export type { TabId };

export function HomeNavigations({ activeTab, onTabChange, onNewRequest }: IHomeNavigationsProps): ReactNode {
  return (
    <div className={styles.topActions}>
      <div className={styles.tabList} role="tablist" aria-label="Request views">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            role="tab"
            type="button"
            className={`${styles.tab} ${activeTab === tab.id ? styles.tabActive : ""}`}
            aria-selected={activeTab === tab.id}
            onClick={(): void => onTabChange(tab.id)}
          >
            <span className={styles.tabTitle}>{tab.label}</span>
            {activeTab === tab.id && (
              <span className={styles.tabIndicator} aria-hidden="true" />
            )}
          </button>
        ))}
      </div>

      <button
        type="button"
        className={styles.newRequestButton}
        aria-label="Create new request"
        onClick={onNewRequest}
      >
        <span aria-hidden="true">+</span>
        <span>New request</span>
      </button>
    </div>
  );
}
